import { useQuery } from "@tanstack/react-query";
import { getBrazeConfig } from "../../api/BrazeApi";

export const useGetBrazeStatus = (organisationId, enabled = true) => useQuery({
  queryKey: ["braze-status", organisationId],
  queryFn: () => getBrazeConfig(organisationId),
  enabled: !!organisationId && enabled,
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: true,
});
